import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IResponseSuccess } from '../core/models/response-sucess.model';
import {
  ChannelAccommodationDownloadMultiPropertyJobStartRequest,
  ChannelAccommodationDownloadMultiPropertyResponse,
} from '../core/models/api/generics/channel-tools-response/channel-tools-response.interface';
import { generateParamArray, generateSearchQuery } from '@app/core/helpers';

@Injectable({
  providedIn: 'root',
})
export class DownloadMappingChannelService {
  constructor(private http: HttpClient) {}

  downloadRoomsMultiProperty(propertyIds: number[], channelId: number) {
    return this.http.get<
      IResponseSuccess<ChannelAccommodationDownloadMultiPropertyJobStartRequest>
    >(
      `channelmanager/properties/accommodations/${channelId}/new?with_channel_response=1&with_channel_request=1&${generateParamArray(
        'property_id',
        propertyIds,
      )}`,
    );
  }

  downloadRoomsMultiPropertyCheckStatus(batchJobId: string, channelId: number) {
    return this.http.get<
      IResponseSuccess<ChannelAccommodationDownloadMultiPropertyResponse>
    >(
      `channelmanager/properties/accommodations/${channelId}/new/${batchJobId}`,
    );
  }

  checkRoomsDeleted(propertyIds: number[], channelId: number) {
    return this.http.get(
      `channelmanager/accommodations/${channelId}/delete?${generateSearchQuery({ with_channel_response: 1, with_channel_request: 1, property_ids: propertyIds })}`,
    );
  }
}
